import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ToggleSliderComponent } from '@shared/components/toggle-slider/toggle-slider.component';
import { RequireLoginDirective } from '@shared/directives/require-login.directive';

@Component({
  selector: 'app-toggle-button-slider',
  templateUrl: './toggle-button-slider.component.html',
  imports: [CommonModule, RequireLoginDirective, TranslateModule],
})
export class ToggleButtonSliderComponent extends ToggleSliderComponent {}
